import { useState } from "react";
import Header from "../components/Layouts/Header";
import Sidebar from "../components/Layouts/Sidebar";
import { ToastContainer } from "react-toastify";

const SIDEBAR_COLLAPSED_KEY = "sidebarCollapsed";

function SidebarLayout({children, sidebar}) {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true"
  );

  const toggleSidebar = () => {
    setSidebarActive((s) => !s);
  };

  const closeSidebar = () => {
    setSidebarActive(false);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed((collapsed) => {
      const next = !collapsed;
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(next));
      return next;
    });
  };

  return(
    <>
      <Header
        toggleSidebar={toggleSidebar}
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebarCollapse={toggleSidebarCollapse}
      />

      <Sidebar
        sidebarActive={sidebarActive}
        closeSidebar={closeSidebar}
        sidebar={sidebar}
        collapsed={sidebarCollapsed}
      />

      <main className={`dashboard-content ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
        {children}
      </main>

      <ToastContainer 
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        autoClose={3000}
        position="top-center"
      />
    </>
  );
}

export default SidebarLayout;